import { axios } from '@/plugins/axios';
import { Item } from '@/models';

export class CSIItemService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/csi/items/';
  }

  async fetchCsiItems(params?: URLSearchParams) {
    return axios
      .get<Item[]>(`${this.endpoint}`, {
        timeout: 5 * (60 * 1000),
        params
      })
      .then(({ data }) => data);
  }

  // TODO: LF-2021-10-04 - Timeout hack should be removed
  async fetchCsiItem(id: number, params?: URLSearchParams) {
    return axios
      .get<Item>(`${this.endpoint}${id}/`, {
        timeout: 5 * (60 * 1000),
        params
      })
      .then(({ data }) => data);
  }
}
